<div class="support">
    <div class="row justify-content-center">
        <h3 class="text-center heading">Help & Support</h3>
        <div class="col-5 mt-3">
            <p class="text-center">
                We'd love to talk to you about how we can help. Please contact the address below and someone from our team will get back to you as soon as possible.
            </p>
        </div>
        <button type="button" class="btn btn-outline-help mt-3" href="mailto:help@studioonsunset.com">Help@StudioOnSunset.com</button>
    </div>
</div>


